var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _g3, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyDiscussion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 228,
    viewBox: "0 0 318 228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.911 0H64.5929C55.6036 0 48.3164 7.28723 48.3164 16.2765V211.594C48.3164 220.584 55.6036 227.871 64.5929 227.871H259.911C268.9 227.871 276.187 220.584 276.187 211.594V16.2765C276.187 7.28723 268.9 0 259.911 0Z",
    fill: "#FFECEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1133_1450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.1226 84.2896H303.855C306.014 84.2896 308.084 85.147 309.61 86.6732C311.136 88.1994 311.994 90.2694 311.994 92.4278V133.119C311.994 135.277 311.136 137.347 309.61 138.874C308.084 140.4 306.014 141.257 303.855 141.257H84.1226C81.9642 141.257 79.8942 140.4 78.368 138.874C76.8418 137.347 75.9844 135.277 75.9844 133.119V92.4278C75.9844 90.2694 76.8418 88.1994 78.368 86.6732C79.8942 85.147 81.9642 84.2896 84.1226 84.2896V84.2896Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.569 97.3105H162.25C159.553 97.3105 157.367 99.4967 157.367 102.193C157.367 104.89 159.553 107.076 162.25 107.076H204.569C207.266 107.076 209.452 104.89 209.452 102.193C209.452 99.4967 207.266 97.3105 204.569 97.3105Z",
    fill: "#FCD7D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M233.867 118.47H162.25C159.553 118.47 157.367 120.656 157.367 123.353C157.367 126.049 159.553 128.236 162.25 128.236H233.867C236.563 128.236 238.75 126.049 238.75 123.353C238.75 120.656 236.563 118.47 233.867 118.47Z",
    fill: "#FCD7D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.627 128.236C134.167 128.236 141.089 121.313 141.089 112.773C141.089 104.233 134.167 97.3105 125.627 97.3105C117.087 97.3105 110.164 104.233 110.164 112.773C110.164 121.313 117.087 128.236 125.627 128.236Z",
    fill: "#FE5558"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1133_1450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1382 154.278H233.871C236.029 154.278 238.099 155.136 239.626 156.662C241.152 158.188 242.009 160.258 242.009 162.417V203.108C242.009 205.266 241.152 207.336 239.626 208.862C238.099 210.389 236.029 211.246 233.871 211.246H14.1382C11.9798 211.246 9.90985 210.389 8.38364 208.862C6.85742 207.336 6 205.266 6 203.108V162.417C6 160.258 6.85742 158.188 8.38364 156.662C9.90985 155.136 11.9798 154.278 14.1382 154.278V154.278Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.585 167.299H92.2658C89.569 167.299 87.3828 169.485 87.3828 172.182C87.3828 174.879 89.569 177.065 92.2658 177.065H134.585C137.281 177.065 139.468 174.879 139.468 172.182C139.468 169.485 137.281 167.299 134.585 167.299Z",
    fill: "#FCD7D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M163.882 188.458H92.2658C89.569 188.458 87.3828 190.645 87.3828 193.341C87.3828 196.038 89.569 198.224 92.2658 198.224H163.882C166.579 198.224 168.765 196.038 168.765 193.341C168.765 190.645 166.579 188.458 163.882 188.458Z",
    fill: "#FCD7D8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6424 198.225C64.1822 198.225 71.105 191.302 71.105 182.762C71.105 174.222 64.1822 167.299 55.6424 167.299C47.1026 167.299 40.1797 174.222 40.1797 182.762C40.1797 191.302 47.1026 198.225 55.6424 198.225Z",
    fill: "#FE5558"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1133_1450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.871 14.3003H14.1382C9.64362 14.3003 6 17.9439 6 22.4385V63.1298C6 67.6244 9.64362 71.268 14.1382 71.268H233.871C238.366 71.268 242.009 67.6244 242.009 63.1298V22.4385C242.009 17.9439 238.366 14.3003 233.871 14.3003Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.327 27.3213H89.0079C86.3112 27.3213 84.125 29.5075 84.125 32.2042C84.125 34.901 86.3112 37.0872 89.0079 37.0872H131.327C134.024 37.0872 136.21 34.901 136.21 32.2042C136.21 29.5075 134.024 27.3213 131.327 27.3213Z",
    fill: "#FCD7D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.625 48.4805H89.0079C86.3112 48.4805 84.125 50.6666 84.125 53.3634C84.125 56.0602 86.3112 58.2464 89.0079 58.2464H160.625C163.321 58.2464 165.507 56.0602 165.507 53.3634C165.507 50.6666 163.321 48.4805 160.625 48.4805Z",
    fill: "#FCD7D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6424 58.2466C64.1822 58.2466 71.105 51.3238 71.105 42.784C71.105 34.2442 64.1822 27.3213 55.6424 27.3213C47.1026 27.3213 40.1797 34.2442 40.1797 42.784C40.1797 51.3238 47.1026 58.2466 55.6424 58.2466Z",
    fill: "#FE5558"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1133_1450",
    x: 69.9844,
    y: 81.2896,
    width: 248.008,
    height: 68.9678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1133_1450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1133_1450",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1133_1450",
    x: 0,
    y: 151.278,
    width: 248.008,
    height: 68.9678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1133_1450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1133_1450",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1133_1450",
    x: 0,
    y: 11.3003,
    width: 248.008,
    height: 68.9678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1133_1450"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1133_1450",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDiscussion);
export default __webpack_public_path__ + "static/media/emptyDiscussion.17719321df0e6b7460023768200240b0.svg";
export { ForwardRef as ReactComponent };